module.exports = __webpack_public_path__ + "img/рз_20.4b8439c0.png";